import { t } from 'ember-intl';
import Divider from 'tio-ui/components/divider';
import {
  PhFlag,
  PhMoney,
  PhFadersHorizontal,
  PhProhibit,
  PhPercent,
  PhLineSegments,
  PhCheck,
} from 'ember-phosphor-icons';

<template>
  <div class="md:flex md:flex-row md:align-middle py-4 px-2 tio-fg-muted">
    <span class="tio-row-center tio-fg-info md:pr-6">
      <PhFlag @size="32" @weight="fill" />
    </span>
    <span class="">
      <div class="p-2 font-bold">
        {{t "planning_for_college.five_two_nine.fed_tax_benefits_title"}}
      </div>
      <div class="p-2 pb-4">
        {{t "planning_for_college.five_two_nine.fed_tax_benefits_text"}}
      </div>
    </span>
  </div>
  <Divider class="my-2" />
  <div class="md:flex md:flex-row md:align-middle py-4 px-2 tio-fg-muted">
    <span class="tio-row-center tio-fg-info md:pr-6">
      <PhMoney @size="32" @weight="fill" />
    </span>
    <span class="">
      <div class="p-2 font-bold">
        {{t "planning_for_college.five_two_nine.state_tax_benefits_title"}}
      </div>
      <div class="p-2 pb-4">
        {{t "planning_for_college.five_two_nine.state_tax_benefits_text"}}
      </div>
    </span>
  </div>
  <Divider class="my-2" />
  <div class="md:flex md:flex-row md:align-middle py-4 px-2 tio-fg-muted">
    <span class="tio-row-center tio-fg-info md:pr-6">
      <PhFadersHorizontal @size="32" @weight="fill" />
    </span>
    <span class="">
      <div class="p-2 font-bold">
        {{t "planning_for_college.five_two_nine.control_title"}}
      </div>
      <div class="p-2 pb-4">
        {{t "planning_for_college.five_two_nine.control_text"}}
      </div>
    </span>
  </div>
  <Divider class="my-2" />
  <div class="md:flex md:flex-row md:align-middle py-4 px-2 tio-fg-muted">
    <span class="tio-row-center tio-fg-info md:pr-6">
      <PhProhibit @size="32" @weight="fill" />
    </span>
    <span class="">
      <div class="p-2 font-bold">
        {{t "planning_for_college.five_two_nine.no_income_restrictions_title"}}
      </div>
      <div class="p-2 pb-4">
        {{t "planning_for_college.five_two_nine.no_income_restrictions_text"}}
      </div>
    </span>
  </div>
  <Divider class="my-2" />
  <div class="md:flex md:flex-row md:align-middle py-4 px-2 tio-fg-muted">
    <span class="tio-row-center tio-fg-info md:pr-6">
      <PhPercent @size="32" @weight="fill" />
    </span>
    <span class="">
      <div class="p-2 font-bold">
        {{t "planning_for_college.five_two_nine.minimal_financial_title"}}
      </div>
      <div class="p-2 pb-4">
        {{t "planning_for_college.five_two_nine.minimal_financial_text"}}
      </div>
    </span>
  </div>
  <Divider class="my-2" />
  <div class="md:flex md:flex-row md:align-middle py-4 px-2 tio-fg-muted">
    <span class="tio-row-center tio-fg-info md:pr-6">
      <PhLineSegments @size="32" @weight="fill" />
    </span>
    <span class="">
      <div class="p-2 font-bold">
        {{t "planning_for_college.five_two_nine.high_contribution_title"}}
      </div>
      <div class="p-2 pb-4">
        {{t "planning_for_college.five_two_nine.high_contribution_text"}}
      </div>
    </span>
  </div>
  <Divider class="my-2" />
  <div class="md:flex md:flex-row md:align-middle py-4 px-2 tio-fg-muted">
    <span class="tio-row-center tio-fg-info md:pr-6">
      <PhCheck @size="32" @weight="fill" />
    </span>
    <span class="">
      <div class="p-2 font-bold">
        {{t "planning_for_college.five_two_nine.flexibility_title"}}
      </div>
      <div class="p-2 pb-4">
        {{t "planning_for_college.five_two_nine.flexibility_text"}}
      </div>
    </span>
  </div>
  <Divider class="my-2" />
  <div class="tio-row-center py-10 px-2">
    <img
      class="w-full max-w-96"
      alt={{t "planning_for_college.five_two_nine.piggy_bank"}}
      src="/assets/images/planning-for-college/529-piggy.png"
    />
  </div>
</template>
